var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 70,
    viewBox: "0 0 72 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6168 0C15.9385 0 0 15.9616 0 35.6684C0 51.4517 10.1953 64.7828 24.353 69.5089C26.1338 69.821 26.8016 68.7509 26.8016 67.8146C26.8016 66.9675 26.7571 64.1586 26.7571 61.1714C17.8084 62.821 15.4933 58.9867 14.781 56.9803C14.3803 55.9549 12.644 52.7893 11.1303 51.9422C9.88366 51.2734 8.10282 49.6237 11.0857 49.5791C13.8906 49.5345 15.894 52.1651 16.5618 53.2351C19.7673 58.63 24.8872 57.1141 26.9352 56.1778C27.2469 53.8593 28.1818 52.2988 29.2058 51.4071C21.281 50.5154 13.0001 47.439 13.0001 33.7958C13.0001 29.9169 14.3803 26.7067 16.6509 24.21C16.2947 23.3182 15.0481 19.6622 17.007 14.7578C17.007 14.7578 19.9899 13.8215 26.8016 18.4138C29.651 17.6113 32.6784 17.21 35.7058 17.21C38.7333 17.21 41.7607 17.6113 44.61 18.4138C51.4218 13.7769 54.4047 14.7578 54.4047 14.7578C56.3636 19.6622 55.117 23.3182 54.7608 24.21C57.0314 26.7067 58.4116 29.8723 58.4116 33.7958C58.4116 47.4836 50.0861 50.5154 42.1614 51.4071C43.4525 52.5218 44.5655 54.6619 44.5655 58.0058C44.5655 62.7765 44.521 66.6108 44.521 67.8146C44.521 68.7509 45.1888 69.8656 46.9697 69.5089C61.0383 64.7828 71.2336 51.4071 71.2336 35.6684C71.2336 15.9616 55.2951 0 35.6168 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/Github-Logo.d38a8787c8306f6e6b8c2cec5fe65fea.svg";
export { ForwardRef as ReactComponent };